import React from 'react';
import { Heart, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About Section */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_13664fd4-6d2c-4c22-baf5-9a2dd54779d6/artifacts/0ucf8pui_Digital_Inclusion_Lab_2026_Logo-removebg-preview.png"
                alt="DIL Logo"
                className="h-10 w-auto"
              />
              <span className="text-white font-bold text-lg">Digital Inclusion Lab</span>
            </div>
            <p className="text-sm leading-relaxed">
              Building a radically inclusive and connected world through technology with empathy.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-[#ffed00] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/#ventures" className="text-sm hover:text-[#ffed00] transition-colors">
                  Our Ventures
                </Link>
              </li>
              <li>
                <Link to="/#about" className="text-sm hover:text-[#ffed00] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/applications" className="text-sm hover:text-[#ffed00] transition-colors">
                  Applications
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-[#ffed00] mt-1 flex-shrink-0" />
                <span className="text-sm">New Delhi, India</span>
              </div>
              <div className="flex items-start gap-3">
                <Mail size={18} className="text-[#ffed00] mt-1 flex-shrink-0" />
                <a href="mailto:hello@digitalinclusionlab.com" className="text-sm hover:text-[#ffed00] transition-colors">
                  hello@digitalinclusionlab.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-center md:text-left">
              Digital Inclusion Lab is an initiative by <span className="font-semibold text-white">Giant-Tree Foundation</span>,
              a not-for-profit Section 8 company registered in New Delhi.
            </p>
            <div className="flex items-center gap-1 text-sm">
              <span>Made with</span>
              <Heart size={14} className="text-[#ff8385] fill-current" />
              <span>for a better world</span>
            </div>
          </div>
          <div className="flex justify-center gap-6 mt-6">
            <a href="#" className="text-xs hover:text-[#ffed00] transition-colors">
              Privacy Policy
            </a>
            <span className="text-gray-600">•</span>
            <a href="#" className="text-xs hover:text-[#ffed00] transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
